import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import useSignOut from 'react-auth-kit/hooks/useSignOut'
import { ROUTES } from '../../routes'
import axiosInstance from '../../services/axiosInstance'

const Logout = () => {
  const navigate = useNavigate()
  const signOut = useSignOut()

  useEffect(() => {
    const run = async () => {
      console.log('Logout effect triggered')
      try {
        const res = await axiosInstance.delete('/logout')
        console.log('Logout response', res)
      } catch (err) {
        console.error('Logout request failed', err)
      } finally {
        signOut()
        navigate(ROUTES.LOGIN)
      }
    }

    run()
  }, [])
}

export default Logout
